import firebaseChatService from '../services/firebaseChatService';
import { chatSdk } from '@wix/chat-sdk';
import wix from '../services/wix';
import { initApp } from './serverApi';
import {
  updateAllowInput,
  updateHasMessages,
  updateIsLcfMandatory,
} from './index';
import { loadingScheduler } from '../services/loading-scheduler';
import { isExperimentOn } from '../reducers';

const handlers = {
  onVisitorMerge: event => (dispatch, getState) => {
    if (event.mergedIntoChatroomId) {
      dispatch(updateAllowInput(true));
    }

    dispatch(
      updateIsLcfMandatory({ ...getState().isLcfMandatory, isContact: true }),
    );
    firebaseChatService.updatePresence({
      isContact: true,
    });

    if (
      !event.mergedIntoChatroomId ||
      event.mergedIntoChatroomId === event.visitorChatroomId
    ) {
      return;
    }

    chatSdk.disconnect();

    return dispatch(
      initApp({
        reconnectData: {
          refresh: true,
          oldVisitorInstanceId: firebaseChatService.visitorInstanceId,
          prevChatToken: getState().coreChatToken,
        },
      }),
    );
  },
  onNewMessage: event => dispatch => {
    void loadingScheduler.triggerInteractivity();
    return dispatch(updateHasMessages(true));
  },
};

const handleIncomingEvents = event => {
  return function(dispatch, getState) {
    if (event.type === 'VisitorMerge') {
      return dispatch(handlers.onVisitorMerge(event));
    }

    if (
      event.type === 'Activity' &&
      event.activity.direction === 'BUSINESS_TO_CUSTOMER'
    ) {
      return dispatch(handlers.onNewMessage(event));
    }
  };
};

interface InitFirebaseParams {
  initData: {
    authKey: string;
    options: object;
    messagePath: string;
    presencePath: string;
    visitorInstanceId: string;
    visitorId: string;
    correlationId: string;
  };
  timestamp: number;
}

export const initFirebase = (action: InitFirebaseParams) => {
  return async function(dispatch, getState) {
    const {
      authKey,
      options,
      messagePath,
      presencePath,
      visitorInstanceId,
      visitorId,
      correlationId,
    } = action.initData;
    const { timestamp } = action;
    await firebaseChatService.init({
      authKey,
      options,
      eventPath: messagePath,
      presencePath,
      biToken: wix.getBiToken(),
      instanceId: wix.getInstanceId(),
      visitorId,
      visitorInstanceId,
      correlationId,
    });
    firebaseChatService.subscribeToEventsAndInfo({
      eventCallback: events => dispatch(handleIncomingEvents(events)),
      timestamp,
    });
    firebaseChatService.reportPresenceSummaryEvents();
    return firebaseChatService.removeOnDisconnect();
  };
};
